export default __webpack_public_path__ + "static/media/icon-22.a1a24251.png";